import cx from 'classnames';
import React from 'react';
import styled from 'styled-components';

import VicServiceLogo from 'components/Icons/VicServiceLogo';
import VisuallyHidden from 'components/VisuallyHidden';
import colors from 'utils/colors';
import device from 'utils/device';

export type ComponentProps = {
  /**
   * (optional) Adjustment text to show next to the Logo with divider, or just show the logo when is undefined/empty string
   */
  text?: string;
  /**
   * (optional) url to go once clicked on
   */
  href?: string;
  /**
   * (Optional) custom classname to append to wrapper element
   */
  className?: string;
  /**
   * (Optional) Custom logo fill color or use the default
   */
  fill?: string;
  /**
   * (Optional) event name to trigger upon clicking the icon logo
   */
  onClick?: (e: React.MouseEvent<EventTarget>) => void;
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
  height: 60px;
`;

const Link = styled.a`
  width: 129px;
  height: 60px;
  object-fit: contain;
`;

const Divider = styled.div`
  content: '';
  transform: rotate(-45deg);
  height: 44.3px;
  transform: skewX(-24deg);
  margin-left: 22px;
  border: solid 1px ${colors.logoOrange};

  @media ${device.isMobile} {
    display: none !important;
  }
`;

const TagLineContainer = styled.div`
  max-width: 170px;
  word-break: break-all;
  word-wrap: break-word;
  overflow-wrap: break-word;
  align-self: center;
  color: ${colors.blueGrey75};
  font-size: 0.87rem;
  line-height: 14px;
  text-align: left;
  padding-left: 20px;
  font-weight: 500;
  margin-top: 4px;

  @media ${device.isMobile} {
    display: none !important;
  }
`;

export const Logo: React.FC<ComponentProps> = ({
  text,
  href = 'https://www.service.vic.gov.au',
  fill,
  onClick = () => {},
  className = ''
}) => (
  <Wrapper className={cx({ [className]: !!className })}>
    <Link target='_self' href={href} onClick={onClick}>
      <VisuallyHidden>Go to the Service Victoria home page</VisuallyHidden>
      <VicServiceLogo fill={fill} />
    </Link>
    {text && (
      <>
        <Divider />
        <TagLineContainer>{text}</TagLineContainer>
      </>
    )}
  </Wrapper>
);

export default Logo;
